var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1335,
    height: 402,
    viewBox: "0 0 1335 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_1295)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_82_1295",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -20,
    width: 1335,
    height: 423
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7098 -20H1309.1C1323.3 -20 1334.81 -8.48933 1334.81 5.70981V376.372C1334.81 390.571 1323.3 402.082 1309.1 402.082H25.7098C11.5106 402.082 0 390.571 0 376.372V5.70981C0 -8.48933 11.5106 -20 25.7098 -20Z",
    fill: "#FDFDFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_82_1295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.288 -0.357422H1309.1C1323.3 -0.357422 1334.81 11.1532 1334.81 25.3524V183.773V376.373C1334.81 390.572 1323.3 402.083 1309.1 402.083H27.288C13.0888 402.083 1.57812 390.572 1.57812 376.373V25.3524C1.57812 11.1532 13.0888 -0.357422 27.288 -0.357422Z",
    fill: "#42A4D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.948 320.744C277.486 160.448 293.596 -49.795 429.931 -148.848C566.265 -247.9 771.196 -198.253 887.658 -37.9577C1004.12 122.338 988.009 332.581 851.675 431.634C715.341 530.686 510.409 481.039 393.948 320.744Z",
    fill: "url(#paint0_linear_82_1295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.327 333.482C520.098 333.482 552.187 338.716 581.182 348.141C662.287 374.504 718.827 433.694 718.827 502.482C718.827 595.819 614.733 671.482 486.327 671.482C357.921 671.482 253.827 595.819 253.827 502.482C253.827 493.055 254.889 483.809 256.976 474.602C275.102 394.634 370.89 333.482 486.327 333.482Z",
    fill: "url(#paint1_linear_82_1295)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525 103.698L377.5 -10L230 103.698L377.5 217.396L414.473 188.896L377.597 160.471L451.347 103.622L488.223 132.047L525 103.698ZM451.202 103.66L377.452 46.8105L303.702 103.66L377.452 160.508L451.202 103.66Z",
    fill: "#F6F6F6",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230 186.904L377.5 300.602L525 186.904L377.5 73.2057L340.527 101.706L377.403 130.13L303.653 186.979L266.777 158.554L230 186.904ZM303.798 186.942L377.548 243.791L451.298 186.942L377.548 130.093L303.798 186.942Z",
    fill: "#F6F6F6",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1369 271.698L1221.5 158L1074 271.698L1221.5 385.396L1258.47 356.896L1221.6 328.471L1295.35 271.622L1332.22 300.047L1369 271.698ZM1295.2 271.66L1221.45 214.811L1147.7 271.66L1221.45 328.508L1295.2 271.66Z",
    fill: "#F6F6F6",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1074 354.904L1221.5 468.602L1369 354.904L1221.5 241.206L1184.53 269.706L1221.4 298.13L1147.65 354.979L1110.78 326.554L1074 354.904ZM1147.8 354.942L1221.55 411.791L1295.3 354.942L1221.55 298.093L1147.8 354.942Z",
    fill: "#F6F6F6",
    fillOpacity: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_1295",
    x1: 629.544,
    y1: 112.711,
    x2: 938.528,
    y2: 537.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_82_1295",
    x1: 505.654,
    y1: 506.775,
    x2: 164.979,
    y2: 506.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_1295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1335,
    height: 402,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashNav);
export default __webpack_public_path__ + "static/media/dash-nav.2ee6f97e64957a2b9e2881ddbd100ca8.svg";
export { ForwardRef as ReactComponent };